import { Box, Paper, Stack, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { useEffect, useRef } from 'react';
import {
  AppFormikSelect,
  AppFormikTextField,
  AppFormikUrlNameList,
} from 'shared/components/AppComponents';

interface BasicInformationFormProps {
  test: any;
}

export const linkOutsideRefField = [
  'title',
  'external_urls',
  'external_provider',
  'status',
];

const LinkOutsideTraining: React.FC<BasicInformationFormProps> = () => {
  const linkOutsideRef = useRef<HTMLDivElement | null>(null);
  const { errors, submitCount } = useFormikContext<any>();

  useEffect(() => {
    if (submitCount === 0) return;
    if (!errors || Object.keys(errors).length === 0) return;

    const linkOutsideError = linkOutsideRefField.some(
      (field) => errors?.[field]
    );

    if (linkOutsideError) {
      linkOutsideRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [errors, submitCount]);

  return (
    <Paper
      variant="outlined"
      className="basic-information-form"
      ref={linkOutsideRef}
    >
      <Typography variant="h6">Basic Information</Typography>
      <Stack spacing={2}>
        <Box className="basic-information-title">
          <AppFormikTextField
            name="title"
            placeholder="Enter Training Name"
            outerLabel
            label="Training Name*"
          />
        </Box>
      </Stack>
      <Box className="basic-information-description">
        <AppFormikSelect
          name="status"
          className="rework-selection"
          notched={false}
          labelId="fix-selection-label"
          testid="solicitor-dropdown"
          MenuProps={{
            className: 'menu-fix-selection single-fix-rework',
          }}
          outerLabel
          placeholder="Select status"
          notEmphasized
          notSelectablePlaceholder
          label="Status"
          items={['Published', 'Draft', 'Archived']}
        />
      </Box>

      <Box mt={3}>
        <AppFormikUrlNameList
          name="external_urls"
          label="External URLs *"
          addButtonTitle="Add Another URL "
          outerLabel
        />
      </Box>

      <Box mt={10}>
        <AppFormikTextField
          name="external_provider"
          placeholder="e.g., Coursera, Linkedin Learning"
          outerLabel
          label="Training Provider"
        />
      </Box>
    </Paper>
  );
};

export default LinkOutsideTraining;
